import { tv } from '../tv';

export type VxProgressRingSize = 'xs' | 'sm' | 'md';

export const progressRingVariants = tv({
  base: 'block shrink-0',
  variants: {
    size: {
      // next to 13px text (the dashboard's "1 out of 4 steps")
      xs: 'size-4.5',
      sm: 'size-6',
      md: 'size-8',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
